import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { INTEGRATION_ASSET } from './schema';

const QUERY = gql`
  query IntegrationAssets(
    $userId: ID
    $customerId: ID!
    $workspaceId: ID
    $dataSource: PerformanceCenterDataSource
    $integrationAssetId: ID
    $accountId: ID
    $statuses: [IntegrationAssetStatus!]
    $refresh: Boolean
  ) {
    integrationAssets(
      userId: $userId
      customerId: $customerId
      workspaceId: $workspaceId
      dataSource: $dataSource
      integrationAssetId: $integrationAssetId
      accountId: $accountId
      statuses: $statuses
      refresh: $refresh
    ) {
      ...IntegrationAsset
    }
  }
  ${INTEGRATION_ASSET}
`;

export const queryIntegrationAssets = ({
  userId,
  customerId,
  workspaceId,
  dataSource,
  integrationAssetId,
  accountId,
  statuses,
  refresh,
}) => {
  return executeGqlQuery({
    variables: {
      userId,
      customerId,
      workspaceId,
      dataSource,
      integrationAssetId,
      accountId,
      statuses,
      refresh,
    },
    query: QUERY,
  }).then(({ data }) => getSingleProp(data));
};
